var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _line, _path14, _path15, _path16, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataCardImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 70,
    viewBox: "0 0 120 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 119,
    height: 65,
    rx: 4.03466,
    fill: "#EAEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.27919C0 1.91586 1.91586 0 4.27919 0H114.721C117.084 0 119 1.91586 119 4.27919V9H0V4.27919Z",
    fill: "#DADAF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.4272H119.084V42.0075H0V34.4272Z",
    fill: "#DCE1EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.998H119.084V55.5783H0V47.998Z",
    fill: "#DCE1EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 62.1807H119.084V65.9708C119.084 68.064 117.387 69.7609 115.293 69.7609H3.66787C1.64216 69.7609 0 68.1188 0 66.0931V62.1807Z",
    fill: "#DCE1EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#231D2C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3C14.4477 3 14 3.44772 14 4C14 4.55228 14.4477 5 15 5H40H43H51C51.5523 5 52 4.55228 52 4C52 3.44772 51.5523 3 51 3H43H40H15Z",
    fill: "#231D2C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5417,
    y: 3,
    width: 13.5711,
    height: 2.32299,
    rx: 1.11036,
    fill: "#231D2C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80.082,
    y: 3,
    width: 10.3923,
    height: 2.32299,
    rx: 1.11036,
    fill: "#231D2C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6877,
    y: 3,
    width: 14.3047,
    height: 2.32299,
    rx: 1.11036,
    fill: "#231D2C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 59.54,
    y: 20,
    width: 30.46,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 59.54,
    y: 25,
    width: 30.46,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 59.54,
    y: 30,
    width: 30.46,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.54,
    y: 20,
    width: 18.7446,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 59.54,
    y: 25,
    width: 28.1169,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 59.54,
    y: 30,
    width: 9.3723,
    height: 2,
    rx: 1,
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4937 13.4672C14.4937 13.2092 14.7029 13 14.9609 13H17.7278C17.9858 13 18.195 13.2092 18.195 13.4672V31.9221H14.4937V13.4672Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1818 26.082C19.1818 25.8239 19.391 25.6147 19.649 25.6147H22.4159C22.6739 25.6147 22.8831 25.8239 22.8831 26.082V31.9221H19.1818V26.082Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8702 28.1845C23.8702 27.9265 24.0794 27.7173 24.3374 27.7173H27.1043C27.3623 27.7173 27.5715 27.9265 27.5715 28.1845V31.9222H23.8702V28.1845Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5583 23.9794C28.5583 23.7214 28.7675 23.5122 29.0255 23.5122H31.7924C32.0504 23.5122 32.2596 23.7214 32.2596 23.9794V31.922H28.5583V23.9794Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6234 30.0532C42.6234 29.7951 42.8326 29.5859 43.0906 29.5859H45.8575C46.1155 29.5859 46.3247 29.7951 46.3247 30.0532V31.922H42.6234V30.0532Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0453 31.8637C38.0453 31.6057 38.2545 31.3965 38.5126 31.3965H41.2279C41.4859 31.3965 41.6951 31.6057 41.6951 31.8637H38.0453Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5368 31.8637C33.5368 31.6057 33.746 31.3965 34.004 31.3965H36.7193C36.9773 31.3965 37.1865 31.6057 37.1865 31.8637H33.5368Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3118 26.082C47.3118 25.8239 47.5209 25.6147 47.779 25.6147H50.5459C50.8039 25.6147 51.0131 25.8239 51.0131 26.082V31.9221H47.3118V26.082Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 31.8053,
    x2: 52,
    y2: 31.8053,
    stroke: "#ADB5BD",
    strokeWidth: 0.233607
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1819 25.5698C98.1819 25.3117 98.3911 25.1025 98.6491 25.1025H101.416C101.674 25.1025 101.883 25.3117 101.883 25.5698V31.4099H98.1819V25.5698Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.87 27.6723C102.87 27.4143 103.079 27.2051 103.337 27.2051H106.104C106.362 27.2051 106.571 27.4143 106.571 27.6723V31.41H102.87V27.6723Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.558 23.4672C107.558 23.2092 107.768 23 108.026 23H110.792C111.05 23 111.26 23.2092 111.26 23.4672V31.4098H107.558V23.4672Z",
    fill: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: 31.385,
    x2: 112,
    y2: 31.385,
    stroke: "#ADB5BD",
    strokeWidth: 0.23
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCardImg);
export default __webpack_public_path__ + "static/media/data-card-img.26c951bfaa230a2000d1d368d542330d.svg";
export { ForwardRef as ReactComponent };